<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>基础配置</span>
    </div>
    <el-tabs v-model="activeName" style="width: 80%" tab-position="left" @tab-click="handleClick">
      <el-tab-pane label="用户管理" name="list">

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item size="mini" label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item size="mini" label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button style="margin-left: 10px;" :loading="loading" icon="el-icon-download" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <el-table
          :data="exceptionUser"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            align="center"
          />
          <el-table-column
            prop="level"
            label="用户等级"
            align="center"
          />
          <el-table-column
            prop="exception_type"
            label="异常类型"
            align="center"
          >
            <template scope="{row}">
              {{ exceptionType[row.exception_type] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="reason"
            label="说明"
            align="center"
          >
            <template scope="{row}">
              <span v-if="row.exception_type ==2">
                <Reward :read-only="true" :value="row.reward" />
              </span>
              <span v-else>{{ row.reason }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="rid"
            align="center"
            label="途径"
            width="200"
          >
            <template scope="{row}">
              {{ ridType[row.rid] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="时间"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template scope="scope">
              <span>-</span>
              <!--              <span v-if="scope.row.exception_type == 2 && scope.row.status==0">-->
              <!--                <el-button size="mini" type="success" @click="retroactive(scope.row.id)">补发</el-button>-->
              <!--              </span>-->
              <!--              <span v-else>-</span>-->
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          @pagination="getExceptionUser"
        />
      </el-tab-pane>
      <el-tab-pane label="配置管理" name="conf">
        <el-row :gutter="10" style="margin-bottom: 10px;">
          <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importBaseCfg" :export-method="exportBaseCfg" />
          <!--          <clear-cache-apply />-->
        </el-row>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="sort"
            align="center"
            label="排序"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.sort" placeholder="排序" />
            </template>
          </el-table-column>

          <el-table-column
            prop="type"
            align="center"
            label="限制类型"
          >
            <template scope="scope">
              <el-select v-model.number="scope.row.type" placeholder="请选择">
                <el-option
                  v-for="item in typeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column
            prop="levelStart"
            align="center"
            label="开始等级"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.level_start" placeholder="开始等级" />
            </template>
          </el-table-column>

          <el-table-column
            prop="levelEnd"
            align="center"
            label="结束等级"
          >
            <template scope="scope">
              <el-input v-model.number="scope.row.level_end" placeholder="结束等级" />
            </template>
          </el-table-column>

          <el-table-column
            prop="reward"
            align="center"
            label="奖励"
            width="200"
          >
            <template scope="scope">
              <reward limit-len="1" :limit-type="limitType" :value="scope.row.reward" />
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="状态"
          >
            <template scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
              />
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            label="操作"
          >
            <template scope="scope">
              <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button size="mini" @click="add">+</el-button>
        <el-button v-prevent-re-click size="mini" type="primary" @click="save">保存</el-button>
      </el-tab-pane>
    </el-tabs>
  </el-card>

</template>

<script>

import {
  delExceptionConfigCfg,
  getExceptionConfigList,
  getExceptionUserList, retroactiveAwards,
  updateExceptionConfig
} from '@/api/config/exception-config'
import Reward from '@/components/Reward/index.vue'
import CommonExcel from '@/components/CommonExcel/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getLastDates } from '@/utils'

export default {
  name: 'Abnormal',
  components: { CommonExcel, Reward },
  data() {
    return {
      total: 0,
      loading: false,
      exceptionUser: [],
      exceptionType: [],
      ridType: [],
      tableData: [],
      queryParams: {
        startDate: '',
        endDate: '',
        pageIndex: 1,
        pageSize: 50,
        level: 1
      },
      typeArr: [
        { label: '单次奖励', value: 1 },
        { label: '当天累计奖励', value: 2 }
      ],
      limitType: [14, 15, 65, 22],
      activeName: 'list'
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(3)
    this.queryParams.endDate = getLastDates(0)
    this.getTables()
    this.getExceptionUser()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getExceptionUser()
    },
    handleClick(tab, event) {

    },
    getExceptionUser() {
      getExceptionUserList(this.queryParams).then(res => {
        this.exceptionUser = res.data.list.data
        this.exceptionType = res.data.list.type
        this.ridType = res.data.list.rid
        this.total = res.data.count
      })
    },
    getTables() {
      getExceptionConfigList().then(res => {
        const data = res.data
        for (const i in data) {
          let status = false
          if (data[i].status) {
            status = true
          }
          data[i].status = status
        }
        this.tableData = data
      })
    },
    add() {
      this.tableData.push({ sort: 1, status: true, type: 1, level_start: 1, level_end: 2, reward: [{ propsId: 15, num: 0 }] })
    },
    del(id) {
      this.$confirm('你确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '再看看',
        type: 'warning'
      }).then(() => {
        delExceptionConfigCfg({ id: id }).then(res => {
          this.msgSuccess('删除成功')
          this.getTables()
        })
      })
    },
    save() {
      const data = JSON.stringify(this.tableData)
      console.log('data', data)
      if (data.length < 1) {
        this.msgError('无数据')
        return
      }
      for (const i in data) {
        if (data[i].status) {
          data[i].status = 1
        }
      }
      updateExceptionConfig({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importBaseCfg(updateInfo) {
      const excelData = updateInfo.data
      this.tableData = []
      for (let i = 0; i < excelData.length; i++) {
        this.tableData.push(excelData[i].sheetData[0])
      }
    },
    exportBaseCfg() {
      const dataArr = []
      const nameArr = []

      for (let i = 0; i < this.tableData.length; i++) {
        nameArr.push('异常配置' + i)
        dataArr.push([this.tableData[i]])
      }
      this.onExport(nameArr, dataArr)
      return Promise.reject()
    },
    onExport(name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = '异常配置'
      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef.makeExcelData(dataArr[i], { sort: '排序', type: '限制类型', level_start: '开始等级', level_end: '结束等级', reward: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }, status: '状态' }})
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    retroactive(id) {
      retroactiveAwards({ id: id }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getExceptionUser()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.sourceStat{
  margin-left: 10px;
  cursor:pointer;
  color: #0e6cff;
  text-decoration:underline;
  text-underline: #1c84c6;
}
</style>
